import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import provinces from '../data/provinces.json';
import amphures from '../data/amphures.json';
import districts from '../data/tambon.json';

const { Option } = Select;

const ThaiAddressSelector = ({ value = {}, onChange, disabled = false, province, amphur, subdistrict }) => {
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [filteredAmphures, setFilteredAmphures] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);

  useEffect(() => {

    if (value) {
      value.province = province;
      value.amphur = amphur;
      value.district = subdistrict;
    } else {
      value = {};
    }

    //console.log('province:', value);
    if (province) {
      const found = provinces.find(p => p.name_th === province);
      if (found) {
        setSelectedProvince(found);
        const amphs = amphures.filter(a => a.province_id === found.id);
        setFilteredAmphures(amphs);
      } else {
        setFilteredAmphures([]);
      }
    }
  }, [value, province, selectedProvince]);

  useEffect(() => {
    if (amphur) {
      const amph = amphures.find(a => a.name_th === amphur);
      if (amph) {
        const dists = districts.filter(d => d.amphure_id === amph.id);
        setFilteredDistricts(dists);
      } else {
        setFilteredDistricts([]);
      }
    }
  }, [value.amphure]);

  const triggerChange = (changedValue) => {

    //value.province = changedValue.province;

    if (changedValue.province) {
      const found = provinces.find(p => p.name_th === changedValue.province);
      if (found) {
        setSelectedProvince(found);
        const amphs = amphures.filter(a => a.province_id === found.id);
        // console.log('อำเภอ', amphs);
        setFilteredAmphures(amphs);
      } else {
        setFilteredAmphures([]);
      }
    }

    if (changedValue.amphure) {
      const amph = amphures.find(a => a.name_th === changedValue.amphure);
      if (amph) {
        const dists = districts.filter(d => d.amphure_id === amph.id);
        console.log('ตำบล', dists);
        setFilteredDistricts(dists);
      } else {
        setFilteredDistricts([]);
      }
    }

    console.log('value', changedValue)

    onChange?.({
      ...value,
      ...changedValue,
    });
  };

  return (
    <>
      <Form.Item name="province" label="จังหวัด">
        <Select
          placeholder="เลือกจังหวัด"
          value={province ? province : value.province}
          showSearch
          onChange={(val) => {
            triggerChange({ province: val, amphure: null, district: null });
          }}
          disabled={disabled}
        >
          {provinces.map(prov => (
            <Option key={prov.id} value={prov.name_th}>{prov.name_th}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="district" label="อำเภอ">
        <Select
          placeholder="เลือกอำเภอ"
          value={value.amphure}
          showSearch
          onChange={(val) => triggerChange({ amphure: val, district: null })}
        // disabled={!province || disabled}
        >
          {filteredAmphures.map(amp => (
            <Option key={amp.id} value={amp.name_th}>{amp.name_th}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="subdistrict" label="ตำบล">
        <Select
          placeholder="เลือกตำบล"
          value={value.district}
          showSearch
          onChange={(val) => triggerChange({ district: val })}
        // disabled={!amphur || disabled}
        >
          {filteredDistricts.map(dist => (
            <Option key={dist.id} value={dist.name_th}>{dist.name_th}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default ThaiAddressSelector;